import template from "./manual_document_capture.html";
import en from "./en.json";
import es from "./es.json";
import mixpanel from "mixpanel-browser";
import { documentScanStartState } from "../../../../base.routes";

class ManualDocumentCaptureController {
    /* @ngInject */
    constructor(IdentificationDocumentService, $scope, $translate, $state) {
        this.IdentificationDocumentService = IdentificationDocumentService;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$state = $state;
        this.formData = {};
        this.saving = false;
        this.onSubmit = this.onSubmit.bind(this);
    }

    $onInit() {
        let ctrl = this;
        ctrl.documentType = ctrl.documentTypes.find(
            (documentType) => documentType.sid === ctrl.documentTypeSid,
        );
    }

    changeDocumentType() {
        let ctrl = this;
        ctrl.formData = {};
        ctrl.saveFailed = false;
    }

    onSubmit({ formData }) {
        let ctrl = this;
        if (ctrl.saving || !ctrl.documentType?.capture_schema) {
            return;
        }

        ctrl.formData = formData;
        ctrl.saving = true;
        ctrl.saveFailed = false;
        ctrl.$scope.$applyAsync();

        let payload = {
            owner: ctrl.growerMembership.grower_organization,
            subject: ctrl.growerMembership.user,
            grower_membership: ctrl.growerMembership.sid,
            document_type: ctrl.documentType.sid,
            captured_data: formData,
        };
        if (ctrl.jobApplicationSid) {
            payload.job_application = ctrl.jobApplicationSid;
        }

        return ctrl.IdentificationDocumentService.create(payload)
            .then(
                function (document) {
                    mixpanel.track("Document information entered", {
                        company_sid: ctrl.growerMembership.grower_organization,
                        document_type_sid: ctrl.documentType.sid,
                        self: ctrl.account.sid === ctrl.growerMembership.user,
                    });
                    ctrl.savedDocument = document;
                },
                function () {
                    ctrl.saveFailed = true;
                },
            )
            .finally(function () {
                ctrl.saving = false;
            });
    }

    cancel() {
        let ctrl = this;
        if (!ctrl.saving) {
            return ctrl.$state.go(documentScanStartState, {
                user_sid: ctrl.growerMembership.user,
                grower_sid: ctrl.growerMembership.grower_organization,
                grower_membership_sid: ctrl.growerMembership.sid,
                job_application: ctrl.jobApplicationSid,
            });
        }
    }

    startAnotherDocument() {
        let ctrl = this;
        ctrl.savedDocument = undefined;
        ctrl.changeDocumentType();
    }
}

export default {
    controller: ManualDocumentCaptureController,
    bindings: {
        account: "<",
        documentTypes: "<",
        documentTypeSid: "<",
        growerMembership: "<",
        jobApplicationSid: "<",
    },
    template: template,
    name: "manualDocumentCapture",
    translations: { en, es },
};
